export const INVALID_URL = 'URL ของคุณไม่ถูกต้อง';
export const IMAGE_ERROR_EXTENSION = 'ไฟล์รูปภาพไม่ถูกต้อง';
export const IMAGE_ERROR_NOT_FOUND = 'กรุณาเพิ่มไฟล์รูปภาพให้ครบถ้วน';
export const IMAGE_ERROR_DIMENSIONS = 'รูปภาพต้องมีขนาด 600 x 600 pixels';
export const SUB_CATAGORY_IS_EMPTY = 'กรุณาเลือก Sub Category';
export const CONTENT_DETAIL_IS_EMPTY = 'กรุณาระบุเนื้อหาของคอนเทนต์';
export const MAX_ORDER_FLEX_PUBLISH_LIMIT =
  'ไม่สามารถอัพเดตได้ เนื่องจากมีจำนวนเนื้อหาที่มีสถานะ Publish เกิน 12 จำนวน';
export const MAX_FLEX_LIMIT_ERROR =
  'เนื้อหาจะถูกปรับสถานะเป็น Unpublish อัตโนมัติ เนื่องจากขณะนี้มีเนื้อหาที่ Publish ครบ 12 จำนวนแล้ว';
export const CONTENT_IS_EMPTY = 'กรุณาเลือก Content';
export const NAME_IS_OVERLIMIT = 'กรุณาระบุชื่อ ไม่เกิน 40 ตัวอักษร';
export const LABEL_IS_OVERLIMIT = 'กรุณาระบุ Label ไม่เกิน 40 ตัวอักษร';
export const DESCRIPTION_IS_OVERLIMIT =
  'กรุณาระบุคำอธิบาย ไม่เกิน 300 ตัวอักษร';
export const CONTENT_IS_OVERLIMIT =
  'กรุณาระบุเนื้อหาบทความ ไม่เกิน 1,000 ตัวอักษร';

export const MAX_LIMIT_NAME = 40;

export const MAX_LIMIT_LABEL = 39;

export const MAX_LIMIT_DESCRIPTION = 300;

export const MAX_LIMIT_CONTENT = 1000;

export const MAX_FLEX_LIMIT = 12;

export const FLEX_ACTION_TYPE = {
  TEXT: 'TEXT',
  LINK_OUT: 'LINKOUT',
  ACTIVATE: 'ACTIVATE',
  LIST_SHOP: 'LISTSHOP',
  SUB_CATAGORY: 'SUBCAT',
  NO_ACTION: 'NOACTION',
  LINK_CONTENT: 'LINKCONTENT',
  REGISTER: 'REGISTER',
  MY_LIST: 'MYLIST',
  TEXT_BY_USER: 'TEXTBYUSER',
  AHAPPY: 'AHAPPY',
  CONTENT: 'CONTENT',
  LIB_SUB_CATAGORY: 'LIBSUBCAT',
  LIBRARY: 'LIBRARY',
};

export const FLEX_ACTION_TYPE_TEXT = {
  TEXT: 'TEXT',
  LINK_OUT: 'LINKOUT',
  ACTIVATE: 'ACTIVATE',
  LIST_SHOP: 'LISTSHOP',
  SUB_CATAGORY: 'SUB CATAGORY',
  LINK_CONTENT: 'LINKCONTENT',
  NO_ACTION: 'NO ACTION',
  MY_LIST: 'MYLIST',
  REGISTER: 'REGISTER',
  TEXT_BY_USER: 'TEXT BY USER',
};

export const ENV_TYPE = {
  OA: 'OA',
  CATEGORY: 'CAT',
  GROUP: 'GROUP',
  SUB_CATEGORY: 'SUBCAT',
  LIB_CATEGORY: 'LIBCAT',
  LIB_SUB_CATEGORY: 'LIBSUBCAT',
};

export const ENV_TYPE_TEXT = {
  OA: 'OA',
  GROUP: 'GROUP',
  CATEGORY: 'CATAGORY',
  SUB_CATEGORY: 'SUB CATEGORY',
};

export const STATUS = {
  PUBLISH: 'PUBLISH',
  UNPUBLISH: 'UNPUBLISH',
  DELETE: 'DELETE',
};

export const USER_TYPE = {
  ALL: 'all',
  ABO: 'abo',
  MEMBER: 'member',
  PUBLIC: 'public',
  EMPLOYEE: 'employee',
};

export const ABO_TYPE = {
  ALL_ABO: 'ALLABO',
  ORDINARY_ABO: 'ORDINARYABO'
}

export const MESSAGE_TYPE = {
  FLEX: 'FLEX',
  FLEX_IMAGE: 'FLEX_IMAGE',
};

export const CONTENT_TYPE = {
  ABUDDY: 'ABUDDY',
  LIBRARY: 'LIBRARY',
};

export const TAG_MESSAGE_ACTION_TYPE = {
  TEXT: 'TEXT',
  TEXT_BY_USER: 'TEXTBYUSER',
  LINK_OUT: 'LINKOUT',
  LINK_CONTENT: 'LINKCONTENT',
  ADD_TO_CART: 'ADDTOCART',
  VIEW_CART: 'VIEWCART'
}

export const SMART_REPORTS_TABLE_HEADERS = [
  'Name',
  'Description',
  'Keyword',
  'Text by User',
  'Display Type',
  'Created Date',
  'Updated Date',
  'สถานะ'
]
